var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58903 9.7845C5.6349 9.85112 5.69628 9.90559 5.76787 9.94322C5.83947 9.98085 5.91914 10.0005 6.00003 10.0005C6.08091 10.0005 6.16059 9.98085 6.23218 9.94322C6.30378 9.90559 6.36516 9.85112 6.41103 9.7845L10.911 3.2845C10.9631 3.20953 10.9937 3.12172 10.9993 3.0306C11.005 2.93949 10.9856 2.84856 10.9433 2.7677C10.9009 2.68683 10.8372 2.61912 10.759 2.57193C10.6809 2.52473 10.5913 2.49986 10.5 2.5H1.50003C1.40895 2.50038 1.3197 2.52557 1.24187 2.57288C1.16404 2.62019 1.10058 2.68782 1.05831 2.7685C1.01605 2.84917 0.996572 2.93985 1.00198 3.03077C1.0074 3.12168 1.03749 3.20941 1.08903 3.2845L5.58903 9.7845Z",
    fill: "#F50E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.4d5b6bb18ae160dc3e6b4be369141b4f.svg";
export { ForwardRef as ReactComponent };